
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 389.62 389.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M119.76 230.88l36.31-3.62c2.19 12.16 6.58 21 13.21 26.76s15.65 8.54 26.91 8.54q17.89 0 27-7.59t9.11-17.79a17 17 0 00-3.81-11.11c-2.53-3.06-7-5.68-13.36-7.92-4.34-1.58-14.22-4.2-29.67-8.07-19.8-5.01-33.8-11.11-41.8-18.37q-16.87-15.31-16.88-37.21a48.41 48.41 0 017.88-26.43c5.34-8.16 13-14.41 23-18.7s22-6.44 36.16-6.44q34.58 0 52.05 15.36c11.69 10.26 17.8 23.9 18.37 41l-37.31 1.29q-2.45-14.25-10.27-20.51c-5.15-4.16-13-6.26-23.37-6.26-10.74 0-19.13 2.25-25.19 6.68a13.63 13.63 0 00-5.87 11.5 14.05 14.05 0 005.53 11.21c4.68 4 16 8.11 34.11 12.41s31.44 8.73 40 13.26a51.92 51.92 0 0120.37 18.75c4.87 8 7.35 17.75 7.35 29.39a54.29 54.29 0 01-8.83 29.67 52.22 52.22 0 01-24.9 20.57c-10.73 4.53-24.09 6.72-40.12 6.72q-34.92 0-53.67-16.12t-22.31-46.97z"}}),_c('path',{staticClass:"a",attrs:{"d":"M176.06 81.8h37.31v39.41h-37.31zm0 193.88h37.31v39.41h-37.31z"}}),_c('path',{staticClass:"a",attrs:{"d":"M50.98 326.18a195.16 195.16 0 01-38.2-201l28.42 11.09a164.22 164.22 0 00244.32 195.12l-8.56-9.72 28.08-5.54.41-.38.21.23 1.44-.26 30.08-5.9-10 28.67-10 28.85-11.23-12.77c-78.78 54.98-188.29 44.4-254.97-28.39zM315.75 83.81c-54.84-59.92-144.37-69.64-210.4-26.84l9 9.48-29.61 7.38-29.39 7.4 8.54-29.35-.81-.89c.52-.48.92-.82 1.4-1.25l7.94-27.41L83.9 34.41c78.76-54.42 188.06-43.88 254.48 28.66a194.17 194.17 0 0137.28 203.73l-28.47-11.11c23.31-57.62 12.15-124.26-31.44-171.88z"}})])
          )
        }
      }
    